import { GameReportType } from '@/hooks/gameReport/useGameReportSearchParams/gameReportType.enum';
import { getMultiplier } from '@/utils/round/getMultiplier';
import { memo } from 'react';
import LastMatchChip from '../../../LastMatches/Chip';
import { LastRoundsChipProps } from './props';

function LastRoundsChip({
  round,
  gameId,
  isBackgroundPaper,
  isLoading,
  modal,
  cover,
}: LastRoundsChipProps) {
  return (
    <LastMatchChip
      link={`?round-slug=${round?.slug}&round-id=${round?.id}&game-id=${gameId}&game-type=${GameReportType.RoundGame}`}
      isBackgroundPaper={isBackgroundPaper}
      modal={modal}
      isLoading={isLoading}
      cover={cover}
    >
      {!isLoading && getMultiplier(round, gameId)}
    </LastMatchChip>
  );
}

export default memo(LastRoundsChip);
